<!-- 单图带输入框 和图片 的上传控件 -->
<template>
	<div class="input-upload" v-if="props.isShowInput">
		<el-input v-model="imageUrl" placeholder="请输入文件路径地址" autocomplete="off" :onChange="handleChange" />
	</div>
	<div class="image-show" v-if="props.isShowImage">
		<el-image class="pic" :src="imageUrl" />
	</div>
	<el-upload class="avatar-uploader" :data="additionalData" :action="uploadImgUrl" :headers="headers" :before-upload="handleBeforeUpload" :on-success="handleUploadSuccess" :show-file-list="false">
		<el-button type="primary">{{ props.btnTitle }}</el-button>
	</el-upload>
</template>

<script setup>
import { ElMessage, ElMessageBox } from 'element-plus'
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	// 父组件 v-model 没有指定参数名，则默认是 modelValue
	modelValue: [String, Object, Array],
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	// 是否显示输入框
	isShowInput: {
		type: Boolean,
		default: true
	},
	// 是否显示图片
	isShowImage: {
		type: Boolean,
		default: true
	},
	// 按钮标题文字
	btnTitle: {
		type: String,
		default: '上传图片'
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址
const imageUrl = ref(defaultImgs.defaultImg)
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

//上传成功, 数据双向绑定
function handleUploadSuccess(res, file) {
	if (res && res.ResData) {
		imageUrl.value = res.ResData.FilePath
		emit('update:modelValue', imageUrl.value)
	} else {
		ElMessage.error(res.ErrMsg)
	}
}
//更新对象值
function handleChange(value) {
	if (value != props.modelValue) {
		imageUrl.value = useImageUrl(value)
		emit('update:modelValue', imageUrl.value)
	}
}
// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(newVal, oldVal) => {
		if (newVal != oldVal) {
			imageUrl.value = useImageUrl(newVal)
		}

		if (imageUrl.value != null && imageUrl.value != '') {
			emit('update:modelValue', imageUrl.value)
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.input-upload {
	width: calc(100% - 140px);
	max-width: calc(100% - 100px);
	min-width: calc(100% - 200px);
	float: left;
}
.image-show {
	margin-left: 5px;
	height: 22px;
	float: left;
	.pic {
		width: 30px;
		height: 30px;
		display: inline-block;
		position: relative;
	}
}
</style>
